module.exports = __webpack_public_path__ + "static/media/brandpreview.fc5a2082.png";